module["exports"] = [
  "01##"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ge/address/postcode.js
// module id = 2358
// module chunks = 2